module.exports = __webpack_public_path__ + "img/album14_24.f48e0df5.jpg";